import React, { useState } from 'react';
import { Button } from './Button';
import { CheckCircle2, AlertCircle } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    service: '',
    message: '',
    consent: false
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      consent: e.target.checked
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
      setFormData({
        name: '',
        company: '',
        email: '',
        phone: '',
        service: '',
        message: '',
        consent: false
      });
    }, 1500);
  };
  if (status === 'success') {
    return <div className="bg-green-50 border border-green-200 rounded-lg p-8 text-center" data-id="element-19">
        <CheckCircle2 className="h-12 w-12 text-green-600 mx-auto mb-4" data-id="element-20" />
        <h3 className="text-xl font-bold text-green-900 mb-2" data-id="element-21">
          Message Sent Successfully
        </h3>
        <p className="text-green-700 mb-6" data-id="element-22">
          Thank you for contacting Brixen Consulting. Our team will review your
          inquiry and get back to you within 24 hours.
        </p>
        <Button variant="outline" onClick={() => setStatus('idle')} data-id="element-23">
          Send Another Message
        </Button>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-6 bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-24">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-25">
        <div data-id="element-26">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-27">
            Full Name *
          </label>
          <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" placeholder="John Doe" data-id="element-28" />
        </div>
        <div data-id="element-29">
          <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-30">
            Company Name
          </label>
          <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" placeholder="Company Ltd." data-id="element-31" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-32">
        <div data-id="element-33">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-34">
            Email Address *
          </label>
          <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" placeholder="john@company.com" data-id="element-35" />
        </div>
        <div data-id="element-36">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-37">
            Phone Number *
          </label>
          <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" placeholder="+971 50 000 0000" data-id="element-38" />
        </div>
      </div>

      <div data-id="element-39">
        <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-40">
          Service Interest *
        </label>
        <select id="service" name="service" required value={formData.service} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all bg-white" data-id="element-41">
          <option value="" data-id="element-42">Select a service...</option>
          <option value="corporate" data-id="element-43">
            Corporate Services (Setup & Structuring)
          </option>
          <option value="brokerage" data-id="element-44">Commercial Brokerage</option>
          <option value="investment" data-id="element-45">Investment Management Support</option>
          <option value="other" data-id="element-46">Other Inquiry</option>
        </select>
      </div>

      <div data-id="element-47">
        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-48">
          Message *
        </label>
        <textarea id="message" name="message" required rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" placeholder="How can we help you?" data-id="element-49"></textarea>
      </div>

      <div className="flex items-start" data-id="element-50">
        <div className="flex items-center h-5" data-id="element-51">
          <input id="consent" name="consent" type="checkbox" required checked={formData.consent} onChange={handleCheckboxChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-52" />
        </div>
        <div className="ml-3 text-sm" data-id="element-53">
          <label htmlFor="consent" className="font-medium text-gray-700" data-id="element-54">
            Privacy Consent *
          </label>
          <p className="text-gray-500" data-id="element-55">
            I agree to the processing of my personal data as described in the
            Privacy Policy.
          </p>
        </div>
      </div>

      <Button type="submit" fullWidth size="lg" isLoading={status === 'submitting'} data-id="element-56">
        Submit Inquiry
      </Button>
    </form>;
}